import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSquares = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.5 14.25H3.75C2.64543 14.25 1.75 13.3546 1.75 12.25V3.75C1.75 2.64543 2.64543 1.75 3.75 1.75H12.25C13.3546 1.75 14.25 2.64543 14.25 3.75V5.5M7.75 18.25H16.25C17.3546 18.25 18.25 17.3546 18.25 16.25V7.75C18.25 6.64543 17.3546 5.75 16.25 5.75H7.75C6.64543 5.75 5.75 6.64543 5.75 7.75V16.25C5.75 17.3546 6.64543 18.25 7.75 18.25Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgSquares);
export { ForwardRef as ReactComponent };
